export default class Sacrificer
{
    constructor(code, name1, name2, name3, name4, family_name, mother_name, city, category, sacrificer){
        this.code        = code
        this.name1       = name1
        this.name2       = name2
        this.name3       = name3
        this.name4       = name4
        this.family_name = family_name
        this.mother_name = mother_name
        this.city        = city
        this.category    = category
        this.sacrificer  = sacrificer
    }
}